import React from "react";
import { IACLEmail, IAuthUser, IntakeConfig } from "intake_shared/src/types";

export const AclContext = React.createContext<
    | { authUser: IAuthUser; userAcl: IACLEmail; intakeConfig: IntakeConfig }
    | undefined
>(undefined);
